import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { ChapterList, ChapterListItem, ContentStatusButton } from 'components';

const ID = 'wholeBook';
const TITLE = 'Entire Book';
const PERCENTAGE = '100.0%';

const useStyles = makeStyles((theme) => ({
  root: {},
  list: {
    alignItems: 'center',
    color: theme.palette.greyBlue[700],
    display: 'flex',
    gap: theme.spacing(0.5),
    justifyContent: 'space-between',
    padding: theme.spacing(0.5, 1, 0.5, 7),
    width: '100%',
  },
  endBlock: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const OfflineContentItemNoTOC = ({ status, statusButtonOnClick, ...props }) => {
  const classes = useStyles();

  const icon = (
    <ContentStatusButton
      status={status}
      onClick={statusButtonOnClick}
      ariaLabelChapterTitle={TITLE}
    />
  );

  const title = (
    <div className={classes.list}>
      <div>
        <span className="noTranslate">{TITLE}</span>
      </div>

      <span className={classes.endBlock}>
        <span className="noTranslate">{PERCENTAGE}</span>
        {icon}
      </span>
    </div>
  );

  return (
    <ChapterList className={classes.root} {...props}>
      <React.Fragment key={ID}>
        <ChapterListItem
          id={ID}
          isNavItem={false}
          orientation="left"
          title={title}
        />
      </React.Fragment>
    </ChapterList>
  );
};

OfflineContentItemNoTOC.propTypes = {
  status: PropTypes.string,
  statusButtonOnClick: PropTypes.func,
};

export default memo(OfflineContentItemNoTOC);
